import getLinkText from "../../../helpers/getLinkText";
import { trackEvent } from "../../../trackEvent";

/**
 * Push any internal links to datalayer when they match the below regex and do not match link testers
 * Note: This should be last in the tester list
 */

const test = ({ target }) => target.closest(".whereToBuyBtn");

const push = ({ link, target }) => {
  const linkText = getLinkText({target, link});

  trackEvent({
    event: "click_cta",
    event_type: "click",
    element_url: link,
    element_text: linkText
  });
};

export default {
  name: "internal",
  test,
  push
};